<div class="backgroundImage">
  <app-header login="yes"></app-header>
  <div class="container">
    <div class="row">
      <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12"></div>

      <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12">
        <div class="sin-in-page-top">
          <div class="card-wrapper">
            <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
              <div style="min-height: 500px">
                <!-- <div class="header main-backgroundcolor color margin-b">
                                    <span (click)="redirect()" style="float: left;"> <i  class="fas fa-arrow-left"></i> </span>
                                    <span> Social Links
                                    </span>
                                </div> -->
                <app-sub-header title="Social Links"></app-sub-header>

                <div
                  formArrayName="socialLinks"
                  *ngFor="
                    let props of form.get('socialLinks')['controls'];
                    let i = index
                  "
                >
                  <div [formGroupName]="i">
                    <div
                      *ngIf="i > 0"
                      class="header main-backgroundcolor color text-center margin-b"
                    >
                      Social Links {{ i + 1 }}
                    </div>

                    <div *ngIf="i != 0" class="form-group">
                      <div style="text-align: right">
                        <button
                          title="Remove"
                          class="btn btn-danger btn-sm cursor"
                          (click)="removeAddress(i)"
                        >
                          <i class="fas fa-trash-alt margin-r"></i>Remove
                        </button>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group register-input">
                          <label class="color" for="form_name"
                            >Website Type</label
                          >

                          <select
                            class="form-control"
                            formControlName="title"
                            (change)="changeTags($event)"
                            [ngClass]="{
                              'is-invalid':
                                submitted && props.get('title').errors
                            }"
                          >
                            <option value="">Select</option>
                            <option *ngFor="let tag of tags" [value]="tag.name">
                              {{ tag.name | titlecase }}
                            </option>
                          </select>

                          <!-- <input class="form-control" type="text" name="streetAddress"
                                                        formControlName="title" placeholder="Website Type"
                                                        [ngClass]="{ 'is-invalid': submitted && props.get('title').errors }"> -->
                          <div
                            *ngIf="submitted && props.get('title').errors"
                            class="invalid-feedback"
                          >
                            <div *ngIf="props.get('title').errors.required">
                              {{ errorMessage }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div class="form-group register-input">
                          <label class="color" for="form_name">Link</label>
                          <input
                            class="form-control"
                            type="text"
                            name="link"
                            formControlName="link"
                            placeholder="Link"
                            [ngClass]="{
                              'is-invalid':
                                submitted && props.get('link').errors
                            }"
                          />
                          <div
                            *ngIf="submitted && props.get('link').errors"
                            class="invalid-feedback"
                          >
                            <div *ngIf="props.get('link').errors.required">
                              {{ errorMessage }}
                            </div>
                            <div
                              *ngIf="props.get('link').errors.invalidProtocol"
                            >
                              Link must start with http:// or https://
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group" style="width: 100%">
                    <div style="text-align: center">
                      <button
                        type="button"
                        (click)="addArr()"
                        class="btn btn-style main-backgroundcolor color"
                      >
                        Add More Social Links
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <button type="submit" class="btn btn-lg btn-block btn-primary">
                Add
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
